import React from 'react';
import { Heading } from '../components/Heading';
import { BiblioPage } from '../components/Biblio/BiblioPage';

export function Biblio() {
    return (
        <>
            <Heading title="Biblio" />
            <BiblioPage />
        </>
    );
}

export default Biblio;
